import type { ReactNode } from 'react';

import { cn } from '../lib/cn';
import { useCopy } from '../lib/use-copy';
import { Button } from './button';
import { GROUP_LABEL } from './group-label';
import { CopyIcon } from './icons';
import { DataPanel } from './layout';

interface ICopyFieldProps {
  value: string;
  display?: ReactNode;
  label?: ReactNode;
  leading?: ReactNode;
  size?: 'md' | 'sm';
  className?: string;
}

export const CopyField = ({
  value,
  display,
  label,
  leading,
  size = 'md',
  className,
}: ICopyFieldProps) => {
  const { copied, copy } = useCopy();

  return (
    <div className={className}>
      {label && <div className={cn('mb-label', GROUP_LABEL)}>{label}</div>}
      <DataPanel className="flex items-center gap-inset py-2">
        {leading}
        <span className="min-w-0 grow truncate font-mono text-data text-primary">
          {display ?? value}
        </span>
        <Button
          variant="ghost"
          size="sm"
          aria-label="Copy"
          onClick={() => void copy(value)}
          className={cn('shrink-0 px-2', size === 'sm' && 'h-6 text-meta')}
        >
          {copied ? 'Copied' : <CopyIcon size={13} />}
        </Button>
      </DataPanel>
    </div>
  );
};
